import { createAction, props } from '@ngrx/store';

export const loadNewTab = createAction(
  '[New Tab] Load New Tab',
  props<{ isNewTabOpen: boolean}>()
);

export const removeNewTab = createAction(
  '[New Tab] Remove  New Tab',
  props<{ isNewTabOpen: boolean }>()
);
